// src/locales/ta/sidebar.js
export const sidebar = {
    collapseTooltip: "பக்கப்பட்டியை மறை",
    expandTooltip: "பக்கப்பட்டியை விரி",
    groupOverview: "மேலோட்டம்",
    groupSales: "விற்பனை & ஆர்டர்கள்",
    groupLogistics: "தளவாடங்கள்",
    groupCatalog: "தயாரிப்பு & சரக்கு",
    groupFinance: "நிதி & அறிக்கைகள்",
    groupPeople: "பணியாளர்கள்",
    groupSystem: "அமைப்பு",
    allOrders: "அனைத்து ஆன்லைன் ஆர்டர்கள்",
    createOrder: "ஆன்லைன் ஆர்டர் உருவாக்கு",
    storePickupOrders: "Store Pickup ஆர்டர்கள்",
    bulkOrderCreate: "மொத்த ஆர்டர் உருவாக்கம்",
    orderAssignment: "ஆர்டர் ஒதுக்கீடு",
    callCenter: "அழைப்பு மையம்",
    assignmentRules: "ஒதுக்கீட்டு விதிகள்",
    manualAssignment: "கைமுறை ஒதுக்கீடு",
    myWorkQueue: "என் வேலை வரிசை",
    packingBatches: "பேக்கிங் பேட்ச்கள்",
    paymentVerification: "பணம் செலுத்துதல் சரிபார்ப்பு",
    dispatchSingleOrder: "ஒற்றை ஆர்டரை அனுப்பு",
    courierUploadFormat: "கூரியர் பதிவேற்ற வடிவம்",
    courierInvoices: "கூரியர் விலைப்பட்டியல்கள்",
    allInvoices: "அனைத்து விலைப்பட்டியல்கள்",
    createInvoice: "விலைப்பட்டியல் உருவாக்கு",
    returnBatches: "திரும்பிய பொருள் பேட்ச்கள்",
    allReturnBatches: "அனைத்து திரும்பிய பொருள் பேட்ச்கள்",
    processReturns: "திரும்பிய பொருட்களை செயல்படுத்து",
    deliveryFollowUp: "டெலிவரி பின்தொடர்தல்",
    settlementBatches: "செட்டில்மென்ட் பேட்ச்கள்",
    returns: "திரும்பிய பொருட்கள்",
    allProducts: "அனைத்து தயாரிப்புகள்",
    addProduct: "தயாரிப்பு சேர்",
    categories: "வகைகள்",
    attributes: "பண்புக்கூறுகள்",
    brands: "பிராண்டுகள்",
    tags: "டேக்குகள்",
    stockOverview: "சரக்கு மேலோட்டம்",
    purchaseOrders: "கொள்முதல் ஆர்டர்கள்",
    stockAdjustments: "சரக்கு மாற்றங்கள்",
    stockTransfers: "கிடங்கு இடமாற்றங்கள்",
    warehouses: "கிடங்குகள்",
    suppliers: "சப்ளையர்கள்",
    goodsReceivedNotes: "பொருள் பெறப்பட்ட குறிப்புகள்",
    returnsToVendor: "விற்பனையாளருக்கு திரும்ப அனுப்புதல்",
    debitNotes: "பற்று குறிப்புகள்",
    payables: "செலுத்த வேண்டியவை",
    expenses: "செலவுகள்",
    messageCenter: "செய்தி மையம்",
    messageCenterShifts: "ஷிப்ட்கள்",
    messageCenterShiftTypes: "ஷிப்ட் வகைகள்",
    messageCenterCommission: "கமிஷன்",
    messageCenterStaffCommission: "ஊழியர் கமிஷன்",
    messageCenterShiftLeaderCommission: "ஷிப்ட் தலைவர் கமிஷன்",
    callCenterShifts: "ஷிப்ட்கள்",
    callCenterCommission: "குறுக்கு விற்பனை கமிஷன்",
    callCenterStaffCommission: "ஊழியர் கமிஷன்",
    allUsers: "அனைத்து பயனர்கள்",
    addUser: "பயனர் சேர்",
    userRoles: "பயனர் பங்குகள்",
    createRole: "பங்கு உருவாக்கு",
    allShops: "அனைத்து கடைகள்",
    addShop: "கடை சேர்",
    salesReports: "விற்பனை அறிக்கைகள்",
    productWiseSales: "Product Wise Sales",
    productWiseReturns: "Product Wise Returns",
    profitAndLoss: "இலாப நட்டம்",
    courierPerformance: "கூரியர் செயல்திறன்",
    messageCenterSummary: "செய்தி மைய சுருக்கம்",
    callCenterSummary: "அழைப்பு மைய சுருக்கம்",
    inventoryReports: "சரக்கு அறிக்கைகள்",
    analytics: "பகுப்பாய்வு",
    courierManagement: "கூரியர் நிர்வாகம்",
    courierAssignmentRules: "கூரியர் ஒதுக்கீட்டு விதிகள்",
    phoneBlacklist: "தொலைபேசி கருப்புப்பட்டியல்",

    woocommerceSync: "WooCommerce ஆர்டர் ஒத்திசைவு",
    openTerminal: "Open Terminal",
    posOrders: "POS ஆர்டர்கள்",
    posCustomers: "POS வாடிக்கையாளர்கள்",
    posSessions: "காசாளர் அமர்வுகள்",
    posSettings: "POS அமைப்புகள்",
    posPaymentMethods: "கட்டண முறைகள்",
    offlineSales: "ஆஃப்லைன் விற்பனை",
    offlineSalesOrders: "ஆஃப்லைன் விற்பனை ஆர்டர்கள்",
    createOfflineSalesOrder: "ஆஃப்லைன் விற்பனை ஆர்டரை உருவாக்கு",
    offlineSalesCustomers: "வாடிக்கையாளர்கள்",
    offlineSalesSessions: "காசாளர் அமர்வுகள்",
    offlineSalesReceivables: "பெற வேண்டிய தொகைகள்",
    offlineSalesCustomerPayments: "வாடிக்கையாளர் கட்டணங்கள்",
    offlineSalesCheques: "காசோலைகள்",
    offlineSalesQuotations: "மேற்கோள்கள்",
    offlineSalesDeliveryNotes: "டெலிவரி குறிப்புகள்",
    offlineSalesReturnNotes: "திரும்பப்பெறும் குறிப்புகள்",
    offlineSalesCreditNotes: "கிரெடிட் குறிப்புகள்",
    offlineSalesSettings: "அமைப்புகள்",
    offlineSalesPaymentMethods: "கட்டண முறைகள்",
    offlineSalesPacking: "கூரியர் பொதி செய்தல்",
    version: "பதிப்பு 1.0.0"
}